<template>
  <div
    v-if="selectedOption"
    :class="selectedOption.style[statusStyle].style"
    :data-test="state"
    class="flex items-center gap-[4px] h-fit w-fit px-[3px] py-[2px]">
    <component
      class="w-3"
      v-if="selectedOption.icon"
      :is="selectedOption.icon"
      :fill1="selectedOption.style[statusStyle].fill1"
      :fill2="selectedOption.style[statusStyle].fill2" />
    <span v-if="!iconOnly">{{ selectedOption.text }} {{ dateActioned }}</span>
  </div>
</template>

<script lang="ts" setup>
import {
  ModuleStatus,
  ModuleType,
  useModuleStatusesStore,
} from '@/store/pinia/ModuleStatusesStore.ts'
import { useUserStore } from '@/store/pinia/UserStore.ts'
import { useFreemium } from '@/composables/freemium/useFreemium.ts'
import { computed } from 'vue'

type Props = {
  state: ModuleStatus | string
  module?: ModuleType
  statusStyle?: 'solid' | 'outline'
  dateActioned?: string
  iconOnly?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  module: undefined,
  statusStyle: 'solid',
  dateActioned: '',
  iconOnly: false,
})

const user = computed(() => useUserStore().getUser)

const { premiumModules, options } = useModuleStatusesStore()

const hasSubscription = computed(
  () => user.value?.subscriptions?.length > 0 && user.value?.active_subscription,
)
const freemiumEnabled = useFreemium().freemiumEnabled

const selectState = () => {
  if (!freemiumEnabled.value || hasSubscription.value || !props.module) {
    return props.state
  }
  return premiumModules.includes(props.module) ? 'upgrade' : props.state
}

const selectedOption = computed(() => options[selectState()] ?? null)
</script>

<style scoped></style>
